import axios from './_contaAxios'

export const obtenertNivelesYCentrosNivelUno = () => axios.get('/centros-costo/niveles-y-centros-nivel-uno')

export const obtenerInfoArbolxId = id => axios.get(`/centros-costo/${id}/info-arbol`)

export const obtenerxNivel = nivel =>
  axios.get('/centros-costo', {
    params: {
      tipoConsulta: 'nivel',
      nivel: nivel
    }
  })

export const obtenerNodosHijosxIdAsSelect = idNodoPadre =>
  axios.get(`/centros-costo/${idNodoPadre}/nodos-hijos`, {
    params: {
      tipoConsulta: 'select'
    }
  })

export const obtenerNivel2xIdNodoPadreAsSelect2 = ({ idNodoPadre, busqueda }) =>
  axios.get(`/centros-costo/${idNodoPadre}/nodos-hijos`, {
    params: {
      tipoConsulta: 'select2',
      busqueda
    }
  })
